module.exports = __webpack_public_path__ + "img/04.fe88daad.png";